import logo from './logo.svg';
import { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import { InputSwitch } from 'primereact/inputswitch';
import { TabView, TabPanel } from 'primereact/tabview';

import GlobalHeader from './components/GlobalHeader'
import GlobalNavigation from './components/GlobalNavigation'
import Card from './components/Card'
import Path from './components/Path'
import RecordHome from './components/RecordHome';
import RecordPageTabs from './components/RecordPageTabs';
import ThemingAgentBot from './components/ThemingAgentBot';
import ThemingWindow from './components/ThemingWindow';
import ColorSystemInfo from './components/ColorSystemInfo';
import HomePageHeader from './components/HomePageHeader';
import HomePageFooter from './components/HomePageFooter';
// import WireFrameLayout from './components/WireFrameLayout';
import ComponentLibrary from './components/ComponentLibrary';

function App() {
  const [useAgentInterface, setUseAgentInterface] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Default to Pages

  const [useDarkMode, setUseDarkMode] = useState(false);

  useEffect(() => {
    const appDiv = document.getElementById('App');
    if (appDiv) {
      appDiv.classList.toggle('slds-color-scheme--dark', useDarkMode);
      appDiv.classList.toggle('slds-color-scheme--light', !useDarkMode);
    }
  }, [useDarkMode]);
  
  const handleAgentIconClick = (message) => {
    if(document.getElementById("Base").classList.contains('agent-open')) {
      document.getElementById("Base").classList.remove('agent-open');
      document.getElementById("App").classList.add('slds-size_4-of-4');
      document.getElementById("App").classList.remove('slds-size_3-of-4');
    }
    else {
      document.getElementById("Base").classList.add('agent-open');
      document.getElementById("App").classList.remove('slds-size_4-of-4');
      document.getElementById("App").classList.add('slds-size_3-of-4');
    }
  }

  // Function to handle automatic tab switching based on form field interactions
  const handleAutoTabSwitch = (tabName) => {
    const tabMap = {
      'color-system': 0,
      'components': 1,
      'pages': 2
    };
    
    if (tabMap[tabName] !== undefined) {
      setActiveTabIndex(tabMap[tabName]);
    }
  };

  return (
    <>
    <HomePageHeader useDarkMode={useDarkMode} setUseDarkMode={setUseDarkMode} />
    <div className="HomePageBody">
      <div id="Base" className='slds-grid slds-p-vertical_x-small'>
        <div className="Chatbot slds-col slds-size_1-of-4 slds-p-horizontal_x-small slds-non-theming-scope">
          {/* <div className="slds-grid slds-grid_align-start slds-p-left_medium slds-p-top_x-small">
            <div className="slds-grid slds-grid_vertical-align-center">
              <span className="slds-m-right_x-small">Standard UI</span>
              <InputSwitch 
                checked={useAgentInterface} 
                onChange={(e) => setUseAgentInterface(e.value)}
                disabled
              />
              <span className="slds-m-left_x-small">Agentic UI</span>
            </div>
          </div> */}
          {useAgentInterface ? <ThemingAgentBot/> : <ThemingWindow onAutoTabSwitch={handleAutoTabSwitch}/>}
        </div>
        <div id="App" className="App slds-col slds-size_3-of-4 slds-theming-scope slds-color-scheme--light">
          <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
            <TabPanel header="Color System">
              <ColorSystemInfo useDarkMode={useDarkMode} />
            </TabPanel>
            <TabPanel header="Components">
              {/* <WireFrameLayout /> */}
              <ComponentLibrary />
            </TabPanel>
            <TabPanel header="Pages">
              <GlobalHeader onIconClick={handleAgentIconClick}/>
              <GlobalNavigation />
              <RecordHome />
              <Card>
                <Path />
              </Card>
              <RecordPageTabs className="slds-card"/>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
    <HomePageFooter />
    </>

  );
}

export default App;
